import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { UtilService } from 'src/app/api/services/util.service';

/**
 * Resolver to evaluate admin status
 */
export const adminResolver: ResolveFn<boolean> = () => {
  return inject(UtilService).isLoggedCompetitorAnAdmin();
};
